module.exports = __webpack_public_path__ + "img/03.22eba40f.jpg";